import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {DashboardProjectsPieChart} from '../dashboard-projects-pie-chart/DashboardProjectsPieChart'

export const DashboardPicClosuresCard = () => {
    const {t} = useTranslation()
    return (
        <DashboardCard title={t('dashboard:pic_closures')}>
            <DashboardProjectsPieChart />
        </DashboardCard>
    )
}
